import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { fromEvent as ObservableFromEvent } from 'rxjs'
import { mergeMap as rxMergeMap, map as rxMap, takeUntil as rxTakeUntil } from 'rxjs/operators'

// components
import { DOMElementRect } from '@aytm/lib/common/func'

import Portal from '@aytm/lib/rfd-ui/components/basic/portal'
import ColorPicker from 'lib/rfd-ui/components/advanced/color-picker'

// styles
import '@aytm/lib/rfd-ui/styles/advanced/color-picker.scss'

class ColorPickerPopup extends Component {
  static propTypes = {
    target: PropTypes.any,
    color: PropTypes.string.isRequired,
    offsetTop: PropTypes.number,
    offsetLeft: PropTypes.number,
    container: PropTypes.any,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func
  }

  constructor(...args) {
    super(...args);
    this.dragModal = this.dragModal.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  popup = null

  dragModal() {
    if (!this.popup) return

    const { container } = this.props
    const popup = this.popup
    const popupHeader = popup.querySelector('.rfd-ui-popup-header')

    if (popup && popupHeader) {
      const mouseup = ObservableFromEvent(document, 'mouseup')
      const mousemove = ObservableFromEvent(document, 'mousemove')
      const mousedown = ObservableFromEvent(popupHeader, 'mousedown')

      const mousedrag = mousedown.pipe(
        rxMergeMap(function (md) {
          // calculate start positions of modal window and cursor
          const popupRect = DOMElementRect(popup)

          const startX = md.clientX
          const startY = md.clientY

          // calculate delta with mousemove until mouseup
          return mousemove.pipe(
            rxMap(function (mm) {
              mm.preventDefault()
              let top = popupRect.top + mm.clientY - startY
              let left = popupRect.left + mm.clientX - startX
              if (container) {
                const containerRect = DOMElementRect(container)
                top = Math.min(containerRect.height - popupRect.height, Math.max(0, top))
                left = Math.min(containerRect.width - popupRect.width, Math.max(0, left))
              }
              return {
                top,
                left
              }
            }),
            rxTakeUntil(mouseup)
          )
        })
      )

      // update position
      this.subscription = mousedrag.subscribe(pos => {
        // TODO
        this.popup.style.top = `${pos.top}px`
        this.popup.style.left = `${pos.left}px`
      })

      const { target } = this.props
      if (target) {
        const { offsetTop, offsetLeft } = this.props
        const targetRect = DOMElementRect(target)
        const popupRect = DOMElementRect(popup)
        let top = targetRect.top + (offsetTop ? offsetTop : targetRect.height)
        let left = targetRect.left + (offsetLeft ? offsetLeft : targetRect.width)
        if (container) {
          const containerRect = DOMElementRect(container)
          top = Math.min(containerRect.height - popupRect.height, Math.max(0, top))
          left = Math.min(containerRect.width - popupRect.width, Math.max(0, left))
        }
        this.popup.style.top = `${top}px`
        this.popup.style.left = `${left}px`
      }
    }
  }

  closePopup() {
    const { onClose } = this.props
    if (onClose) {
      onClose()
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.dragModal()
    }, 0)
  }

  componentWillUnmount() {
    if (this.subscription) this.subscription.unsubscribe()
  }

  render() {
    const { color, readOnly, onChange } = this.props

    return (
      <Portal>
        <div
          className={'rfd-ui-popup rfd-ui-colorpicker-popup'}
          ref={div => {
            this.popup = div
          }}
        >
          <div className={'rfd-ui-popup-header'}>
            Color Picker
            <div className={'rfd-ui-popup-close-button'} onClick={this.closePopup}>
              <i className="icon-aytmfd-close" />
            </div>
          </div>
          <div className={'rfd-ui-popup-content'}>
            <ColorPicker color={color} readOnly={readOnly} onChange={onChange} />
          </div>
        </div>
      </Portal>
    )
  }
}

export default ColorPickerPopup
